// extracted by css-extract-rspack-plugin
export default {"spaceSmall":"12px","spaceFluid":"100%","cancelForm":"reason-form__cancelForm___H8BOF"};